<div [ngClass]="'dark'" style="min-height: 100vh;">

  <div fxLayout="row wrap" fxLayoutGap="10px" fxLayoutAlign="start center" style="padding: 10px" >
    
    <a href="https://siteland.eu/" class="top-3">
      <img src="https://siteland.eu/favicon/favicon-32x32.png">
    </a>
  
    <span fxFlex></span>
  
    <div style="background: grey;padding: 5px">

      <mat-checkbox (change)="showHints = !showHints">Show Hints</mat-checkbox>
    
      <mat-form-field appearance="fill">
        <mat-label>Difficulty</mat-label>
        <mat-select [(ngModel)]="difficulty">
          <mat-option *ngFor="let d of difficulties" [value]="d">
            {{d}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    
      <mat-icon (click)="renderAnimatingSudoku()">
        refresh
      </mat-icon>

    </div>
  
  
  </div>
  
  <div *ngIf="sudoku" style="padding: 20px;" fxLayoutAlign="center center">
    <div class="sudoku" fxLayout="row wrap">
      <div 
        fxLayoutAlign="center center"
        class="cell bg-purple-{{cell.blockIndex}}" 
        *ngFor="let cell of sudoku.cells; let i = index" 
        [ngClass]="cell.hasStaticVal ? 'static-cell' : 'dynamic-cell'"
        [style.color]="cell.hasStaticVal ? '#b1b1b1' : cell.isValid === false && showHints ? 'red' : ''"
        matRipple 
        [matMenuTriggerFor]="menu">
  
        <!-- {{ cell | json }} -->
        <span *ngIf="cell.val && sudoku.currentCell === 81">
           {{cell.val}}
          <!-- {{cell.blockIndex}} -->
          
        </span>
        <small>
          <!-- {{cell.ind}} -->
        </small>
        <!-- <h3 color="warn" *ngIf="cell.val">
          {{cell.val}}
        </h3> -->
  
        <mat-menu #menu="matMenu" class="numpad-menu">
          
          <div fxLayout="row wrap">
            
            <div matRipple fxFlex="33" class="ripple-container"
              *ngFor="let j of [1,2,3,4,5,6,7,8,9];"
              (click)="addValueToCell(cell, j)">
              {{ j }}
            </div>
          
          </div>
  
  
        </mat-menu>
  
      </div>
    </div>
  </div>

</div>

